module.exports = __webpack_public_path__ + "img/ticket4_w.845353bd.svg";